import InvestorInvestmentDetailBanner from './investor-investment-detail-banner';

export default InvestorInvestmentDetailBanner;
